import { useCallback, useState } from 'react';

//services
import { getExamInfo } from 'services/sessions';

//interfaces
import { IExamInfo } from 'services/interfaces/IExam';

export const useGetExamInfo = () => {
  const [examInfo, setExamInfo] = useState<IExamInfo | null>(null);

  const handleGetExamInfo = useCallback(
    async (idBasis: string | number, idModule: string | number) => {
      try {
        const resp = await getExamInfo(idBasis, idModule);
        if (resp) setExamInfo(resp);
      } catch (e) {
        console.log(e);
      }
    },
    []
  );

  return { examInfo, handleGetExamInfo };
};
